import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import useWorkshopQuery from 'hooks/useWorkshopQuery';

async function update(axios: AxiosInstance, id: number | undefined): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/workshop/${id}/unlock`, {});
  return data;
}

export default function useUnlockWorkshopMutation(workshopId: number) {
  const queryClient = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: (params: { id: number }) => update(axios, params.id),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: useWorkshopQuery.getKey(workshopId) });
    },
  });
}
